import React, { useState, useEffect, useCallback } from 'react';

const FESTIVALS = [
  { name: 'Ziro Music Festival', location: 'Ziro Valley, Arunachal Pradesh', month: 'September', category: 'Music' },
  { name: 'Raid de Himalaya', location: 'Shimla to Leh', month: 'October', category: 'Motorsport' },
  { name: 'Hemis Festival', location: 'Hemis, Ladakh', month: 'June', category: 'Culture' },
  { name: 'Chadar Trek', location: 'Zanskar, Ladakh', month: 'January', category: 'Adventure' },
  { name: 'Kullu Dussehra', location: 'Kullu, Himachal Pradesh', month: 'October', category: 'Culture' },
  { name: 'Kasauli Rhythm & Blues', location: 'Kasauli, Himachal Pradesh', month: 'April', category: 'Music' },
  { name: 'Royal Enfield Himalayan Odyssey', location: 'Manali to Leh', month: 'July', category: 'Motorsport' },
  { name: 'Dharamshala International Film Festival', location: 'Dharamshala, Himachal Pradesh', month: 'November', category: 'Film' },
  { name: 'Himalayan Echoes', location: 'Kumaon, Uttarakhand', month: 'November', category: 'Literature' },
  { name: 'MTB Himalaya', location: 'Shimla to Kullu', month: 'September', category: 'Adventure' },
  { name: 'Losar Festival', location: 'Spiti Valley, Himachal Pradesh', month: 'February', category: 'Culture' },
  { name: 'Manali Winter Carnival', location: 'Manali, Himachal Pradesh', month: 'January', category: 'Festival' },
  { name: 'Mussoorie Writers Festival', location: 'Mussoorie, Uttarakhand', month: 'October', category: 'Literature' },
  { name: 'Sindhu Darshan', location: 'Leh, Ladakh', month: 'June', category: 'Culture' },
  { name: 'Himalayan Bike Festival', location: 'Manali, Himachal Pradesh', month: 'June', category: 'Motorsport' },
  { name: 'Minjar Fair', location: 'Chamba, Himachal Pradesh', month: 'July', category: 'Culture' },
  { name: 'Maha Shivaratri at Mandi', location: 'Mandi, Himachal Pradesh', month: 'February', category: 'Festival' },
  { name: 'Great Himalayan Run', location: 'Manali, Himachal Pradesh', month: 'March', category: 'Adventure' },
  { name: 'Lavi Fair', location: 'Rampur, Himachal Pradesh', month: 'November', category: 'Culture' },
  { name: 'Shimla Summer Festival', location: 'Shimla, Himachal Pradesh', month: 'May', category: 'Festival' },
  { name: 'Saga Dawa', location: 'Gangtok, Sikkim', month: 'May', category: 'Culture' },
  { name: 'Pang Lhabsol', location: 'Sikkim', month: 'August', category: 'Culture' },
];

const BG_IMAGES = [
  'https://images.unsplash.com/photo-1764219313598-c7cb7b795d7d?w=1600&q=80',
  'https://images.unsplash.com/photo-1761587600982-55c15b9bb6b8?w=1600&q=80',
  'https://images.unsplash.com/photo-1761470252477-0d260bd20b59?w=1600&q=80',
  'https://images.unsplash.com/photo-1761483614204-2f4c7313d352?w=1600&q=80',
];

const CATEGORY_COLORS = {
  Music: '#C19A6B',
  Motorsport: '#8B6F47',
  Culture: '#7A8B6F',
  Adventure: '#6F7A8B',
  Literature: '#8B7A6F',
  Film: '#6F8B7A',
  Festival: '#9B8B6F',
};

export default function HimalayanFestivalBanner() {
  const [current, setCurrent] = useState(0);
  const [bgIndex, setBgIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const advance = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      setCurrent(prev => (prev + 1) % FESTIVALS.length);
      setBgIndex(prev => (prev + 1) % BG_IMAGES.length);
      setVisible(true);
    }, 600);
  }, []);

  useEffect(() => {
    const interval = setInterval(advance, 4000);
    return () => clearInterval(interval);
  }, [advance]);

  const fest = FESTIVALS[current];
  const catColor = CATEGORY_COLORS[fest.category] || '#8B7A6F';

  return (
    <section className="relative overflow-hidden" data-testid="festival-banner" style={{ height: '340px' }}>
      {/* Background images with Ken Burns */}
      {BG_IMAGES.map((img, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-[2000ms]"
          style={{
            opacity: bgIndex === i ? 1 : 0,
            animation: bgIndex === i ? 'kenburns 20s ease-in-out infinite alternate' : 'none',
          }}
        >
          <img src={img} alt="" className="w-full h-full object-cover" style={{ transform: 'scale(1.1)' }} />
        </div>
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/75" />

      {/* Grain texture overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")',
      }} />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        {/* Top label */}
        <div
          className="transition-all duration-500 mb-6"
          style={{ opacity: visible ? 0.7 : 0, transform: visible ? 'translateY(0)' : 'translateY(-8px)' }}
        >
          <p className="text-white/70 text-[10px] tracking-[0.5em] uppercase">
            The Himalayan Calendar
          </p>
        </div>

        {/* Category badge */}
        <div
          className="transition-all duration-500 mb-5"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(10px)' }}
        >
          <span
            className="text-[10px] tracking-[0.25em] uppercase font-medium px-4 py-1.5 rounded-full border"
            style={{
              color: catColor,
              borderColor: `${catColor}50`,
              backgroundColor: `${catColor}12`,
            }}
          >
            {fest.category}
          </span>
        </div>

        {/* Festival name */}
        <div
          className="transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.97)' }}
        >
          <h3
            className="text-3xl sm:text-4xl md:text-5xl text-white font-light italic tracking-tight leading-tight drop-shadow-lg"
            style={{ fontFamily: "'Playfair Display', Georgia, serif", textShadow: '0 2px 20px rgba(0,0,0,0.5)' }}
          >
            {fest.name}
          </h3>
        </div>

        {/* Location + Month */}
        <div
          className="transition-all duration-500 mt-5 flex items-center gap-3"
          style={{ opacity: visible ? 0.8 : 0, transform: visible ? 'translateY(0)' : 'translateY(12px)', transitionDelay: '100ms' }}
        >
          <span className="text-white/80 text-xs tracking-[0.2em] uppercase">
            {fest.location}
          </span>
          <span className="w-1 h-1 rounded-full bg-white/50" />
          <span className="text-white/60 text-xs tracking-[0.2em] uppercase">
            {fest.month}
          </span>
        </div>

        {/* Progress dots */}
        <div className="flex items-center gap-1.5 mt-8" style={{ opacity: 0.4 }}>
          {[0, 1, 2, 3, 4].map(i => (
            <div
              key={i}
              className="rounded-full transition-all duration-300"
              style={{
                width: current % 5 === i ? '20px' : '4px',
                height: '4px',
                backgroundColor: current % 5 === i ? '#C19A6B' : 'rgba(255,255,255,0.3)',
              }}
            />
          ))}
        </div>
      </div>

      {/* Bottom subtle tagline */}
      <div className="absolute bottom-4 left-0 right-0 text-center z-10">
        <p className="text-white/20 text-[9px] tracking-[0.4em] uppercase">
          Experiences across the Indian Himalayas
        </p>
      </div>

      <style>{`
        @keyframes kenburns {
          0% { transform: scale(1.05) translate(0, 0); }
          100% { transform: scale(1.15) translate(-1%, -1%); }
        }
      `}</style>
    </section>
  );
}
